export const SHOW_LOADING = "SHOW_LOADING";
export const HIDE_LOADING = "HIDE_LOADING";

export function showLoading(msg) {
    return {type: SHOW_LOADING, msg}
}
export function hideLoading() {
    return {type: HIDE_LOADING}
}


// WEBPACK FOOTER //
// ./components/redux/loading/action.js